import React from "react";

export const PharmacyContext = React.createContext(null);